// extracted by mini-css-extract-plugin
export default {"bgHeader":"Header_bgHeader__VfzXH","imglogo":"Header_imglogo__EjKh7","rating":"Header_rating__fEG1f","ratingBox":"Header_ratingBox__rfKGJ","phone":"Header_phone__6wPAz"};